import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import RewardsItemForm from "./RewardsItemForm";

const RewardsSubPage = ({isAddSubMode, kind}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="reward"
            modeApiName2="rewards"
            ItemFormComponent={RewardsItemForm}
            browserStyle={{width: "min(35%, 460px)", minWidth: "310px"}}
            browserFilterExtraParams={{kinds: kind}}
            pageOptions={{kind: kind}}
        />
    );
};

export default RewardsSubPage;